/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

import React from 'react';
import GlobalStyle from './src/styles/globalStyles';

export const wrapRootElement = ({ element }) => (
  <>
    <GlobalStyle />
    {element}
  </>
);

export const onClientEntry = () => {
  if (typeof window !== 'undefined') {
    // Можно заменить на свой инстанс LibreTranslate
    window.__LT_ENDPOINT__ = 'https://translate.astian.org/translate';
  }
};
